import UrlPattern from 'url-pattern';
/**
 *
 */
var RouteObject = /** @class */ (function () {
    /**
     *
     * @param path
     * @param requiresAuth
     * @param ignoreDeeplink
     * @param isPublic
     * @param isInitial
     */
    function RouteObject(path, requiresAuth, ignoreDeeplink, isPublic, isInitial) {
        if (requiresAuth === void 0) { requiresAuth = true; }
        if (ignoreDeeplink === void 0) { ignoreDeeplink = false; }
        if (isPublic === void 0) { isPublic = false; }
        if (isInitial === void 0) { isInitial = false; }
        this.path = path;
        this.pattern = new UrlPattern(path);
        this.requiresAuth = requiresAuth;
        this.ignoreDeeplink = ignoreDeeplink;
        this.isPublic = isPublic;
        this.isInitial = isInitial;
    }
    /**
     *
     * @param data
     * @return {*}
     */
    RouteObject.prototype.getPath = function (data) {
        if (data === void 0) { data = {}; }
        return this.pattern.stringify(data);
    };
    /**
     * Get object with replaced :values
     *
     * @param location The current location of the browser
     */
    RouteObject.prototype.getVariables = function (location) {
        var ls = location.split('/');
        var ps = this.path.split('/');
        var i = 0;
        var result = {};
        while (i < ls.length && i < ps.length) {
            if (ps[i].indexOf(':') >= 0) {
                result[ps[i].replace(':', '')] = ls[i];
            }
            i++;
        }
        return result;
    };
    /**
     *
     * @param path
     * @return {*}
     */
    RouteObject.prototype.match = function (path) {
        return this.pattern.match(path);
    };
    RouteObject.prototype.matchRoute = function (routeObject) {
        return this.pattern.match(routeObject.path);
    };
    RouteObject.prototype.containsRoute = function (routeObject) {
        console.log('containsRoute', routeObject);
        var compare = new UrlPattern(this.path + '*');
        console.log('\t', this.path + '*', routeObject.path, compare.match(routeObject.path));
        return compare.match(routeObject.path);
    };
    return RouteObject;
}());
export default RouteObject;
